import { GroupedCampaignMembership } from "@/types";

type PermissionsState = {
  loading: boolean;
  memberships: GroupedCampaignMembership[];
  is_admin: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  mfa_enabled: boolean;
  mfa_required: boolean;  
}

const defaultState = {
  loading: true,
  memberships: [],
  is_admin: false,
  is_staff: false,
  is_superuser: false,
  mfa_required: false,
  mfa_enabled: false,
};

const normalizeMemberships = (memberships: any[] = []): GroupedCampaignMembership[] => {
  const byCampaignId = new Map<number, GroupedCampaignMembership>();

  for (const membership of memberships) {
    if (!membership?.campaign) continue;

    const roles = membership.roles ?? (membership.role ? [membership.role] : []);
    const existing = byCampaignId.get(membership.campaign.id);

    if (!existing) {
      byCampaignId.set(membership.campaign.id, {
        campaign: membership.campaign,
        roles: [...roles],
      });
      continue;
    }

    for (const role of roles) {
      if (!existing.roles.some((existingRole) => existingRole.id === role.id)) {
        existing.roles.push(role);
      }
    }
  }

  return Array.from(byCampaignId.values());
};

const permissions = function (state:PermissionsState = defaultState, action:any) {

  switch (action.type) {
    case "SET_MEMBERSHIPS":
      const {memberships, account} = action;
      const profile = account?.profile || {};
      const normalizedMemberships = normalizeMemberships(memberships);
      return {
        ...state,
        loading: false,
        is_admin: normalizedMemberships.some(m => m.roles.some(r => r.name === 'admin')),
        is_staff: !!account?.is_staff,
        is_superuser: !!account?.is_superuser,
        memberships: normalizedMemberships,
        ...profile
      };
    case "persist/REHYDRATE":
      if (action.payload?.permissions?.memberships) {
        const rehydratedMemberships = normalizeMemberships(action.payload.permissions.memberships);
        return {
          ...state,
          ...action.payload.permissions,
          memberships: rehydratedMemberships,
          is_admin: rehydratedMemberships.some(m => m.roles.some(r => r.name === 'admin')),
        };
      }
      return state;
    default:
      return state;
  }
};

export default permissions;
